module.exports = __webpack_public_path__ + "assets/img/usersIcon.b13b13d4.svg";